// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages-security-style----stats-module---container---1PVZg marginTop-l marginBottom-xl paddingTop-m overflow-hidden position-relative bg-licorice","centered":"src-pages-security-style----stats-module---centered---1E91b breakPointM-alignContent-stretch centered position-relative breakPointM-display-flex width-90","whitePiece":"src-pages-security-style----stats-module---whitePiece---9EseT bg-white position-absolute"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/security/style/stats.module.css
// module id = 759
// module chunks = 3627797113349 20562973939449